import { useState } from 'react';
import { Button, ControlLabel, Form, FormGroup, Modal } from 'react-bootstrap';
import { textareaNoResize } from './styles/styles';

export enum EntityType {
    Center = 1,
    OPO = 2
}

type TProps = {
    loading: boolean,
    entityType: EntityType,
    entityId: number,
    entityName: string,
    isShippingAddressCompliant?: boolean,
    onPlaceOrder: (entityId: number, quantity: number, notes: string) => void,
}

const PlaceOrder = ({ loading, entityType, entityId, entityName, isShippingAddressCompliant, onPlaceOrder }: TProps) => {
    const [show, setShow] = useState<boolean>(false);
    const [quantity, setQuantity] = useState<string>('1');
    const [notes, setNotes] = useState<string>('');

    const handleQtyChange = (event) => {
        const input = event.target.value;

        // Allow empty input
        if (input === '') {
            setQuantity('');
            return;
        }

        // Allow '0' or numbers without leading zeros
        if (input === '0' || /^[1-9][0-9]*$/.test(input)) {
            setQuantity(input);
        }

    };

    const save = () => {
        onPlaceOrder(
            // strongBoxCenterId: listing.id,
            entityId,
            parseInt(quantity),
            notes || undefined
        );

        setShow(false);
    };

    const cancel = () => {
        setQuantity('1');
        setNotes('');
        setShow(false);
    }

    const tooltip = isShippingAddressCompliant ? `Place Order is disabled because this Strongbox center has not confirmed its address.` : '';
    const disableButton = entityType == EntityType.Center ? !isShippingAddressCompliant : false;

    return (
        <>
            <Button bsSize='xs' bsStyle='primary' onClick={() => setShow(true)} disabled={disableButton} title={tooltip}>Place Order</Button>

            <Modal bsSize='small' backdrop='static' show={show} onHide={cancel}>
                <Modal.Header closeButton>
                    <Modal.Title>Place Order</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {entityType == EntityType.OPO ?
                            <FormGroup>
                                <ControlLabel>OPO</ControlLabel>{' '}
                                <label className='form-control disabled'>{entityName}</label>
                            </FormGroup>
                            :
                            <FormGroup>
                                <ControlLabel>Center</ControlLabel>{' '}
                                <label className='form-control disabled'>{entityName}</label>
                            </FormGroup>
                        }

                        <FormGroup>
                            <ControlLabel>Quantity</ControlLabel>{' '}
                            <input className='form-control' type='number' min='0' step='1' onChange={handleQtyChange} value={quantity} />
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Note</ControlLabel>{' '}
                            <textarea className='form-control' rows={3} maxLength={500} style={textareaNoResize} onChange={(e) => setNotes(e.target.value)} value={notes} />
                        </FormGroup>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={save} disabled={loading || !quantity || quantity === '0'}>Submit Order</Button>
                    <Button onClick={cancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default PlaceOrder